import React from 'react';

import {
    Box,
    Typography,
    useMediaQuery,
} from '@material-ui/core';

import {
    makeStyles,
    useTheme,
} from '@material-ui/core/styles';

import {
    format as date_fns_format,
    parseISO,
} from "date-fns";
import { fr } from "date-fns/locale";

import {
    merge as lodashMerge
} from 'lodash';





//
// Style propre au composant
//
// ATTENTION : ici, il est nécessaire de définir 'useStyle' comme une fonction retournant
// le résultat de 'makestyle' et non pas directement comme le résultat de 'makestyle'. En
// effet, la valeur retournée par 'makeStyles' doit être recalculée à chaque rendu, sinon
// les valeurs associées aux "media queries" semblent ne pas être mises à jour mais
// uniquement la partie 'common' (les 'media query' semblent ne pas être recalculées)
//
const useStyles = () => makeStyles((theme) => ({

    contentArticleDetailTitle: style => ({
        ...style.contentArticleDetailTitle.common,

        [theme.breakpoints.only('xs')]: {
            ...style.contentArticleDetailTitle.xs,
        },
        [theme.breakpoints.only('sm')]: {
            ...style.contentArticleDetailTitle.sm,
        },
        [theme.breakpoints.only('md')]: {
            ...style.contentArticleDetailTitle.md,
        },
        [theme.breakpoints.only('lg')]: {
            ...style.contentArticleDetailTitle.lg,
        },
        [theme.breakpoints.only('xl')]: {
            ...style.contentArticleDetailTitle.xl,
        },
    }),

    contentArticleDetailRoot: style => ({
        ...style.contentArticleDetailRoot.common,

        [theme.breakpoints.only('xs')]: {
            ...style.contentArticleDetailRoot.xs,
        },
        [theme.breakpoints.only('sm')]: {
            ...style.contentArticleDetailRoot.sm,
        },
        [theme.breakpoints.only('md')]: {
            ...style.contentArticleDetailRoot.md,
        },
        [theme.breakpoints.only('lg')]: {
            ...style.contentArticleDetailRoot.lg,
        },
        [theme.breakpoints.only('xl')]: {
            ...style.contentArticleDetailRoot.xl,
        },
    }),

    contentArticleDetailHeaderImg: style => ({
        ...style.contentArticleDetailHeaderImg.common,

        [theme.breakpoints.only('xs')]: {
            ...style.contentArticleDetailHeaderImg.xs,
        },
        [theme.breakpoints.only('sm')]: {
            ...style.contentArticleDetailHeaderImg.sm,
        },
        [theme.breakpoints.only('md')]: {
            ...style.contentArticleDetailHeaderImg.md,
        },
        [theme.breakpoints.only('lg')]: {
            ...style.contentArticleDetailHeaderImg.lg,
        },
        [theme.breakpoints.only('xl')]: {
            ...style.contentArticleDetailHeaderImg.xl,
        },
    }),

    contentArticleDetailContent: style => ({
        ...style.contentArticleDetailContent.common,

        [theme.breakpoints.only('xs')]: {
            ...style.contentArticleDetailContent.xs,
        },
        [theme.breakpoints.only('sm')]: {
            ...style.contentArticleDetailContent.sm,
        },
        [theme.breakpoints.only('md')]: {
            ...style.contentArticleDetailContent.md,
        },
        [theme.breakpoints.only('lg')]: {
            ...style.contentArticleDetailContent.lg,
        },
        [theme.breakpoints.only('xl')]: {
            ...style.contentArticleDetailContent.xl,
        },
    }),

    contentArticleDetailSignatureDate: style => ({
        ...style.contentArticleDetailSignatureDate.common,

        [theme.breakpoints.only('xs')]: {
            ...style.contentArticleDetailSignatureDate.xs,
        },
        [theme.breakpoints.only('sm')]: {
            ...style.contentArticleDetailSignatureDate.sm,
        },
        [theme.breakpoints.only('md')]: {
            ...style.contentArticleDetailSignatureDate.md,
        },
        [theme.breakpoints.only('lg')]: {
            ...style.contentArticleDetailSignatureDate.lg,
        },
        [theme.breakpoints.only('xl')]: {
            ...style.contentArticleDetailSignatureDate.xl,
        },
    }),

}));



//
// Composant permettant d'afficher le détail d'un article
//
export const ContentArticleDetail = ({ title, params, style, data, ...props }) => {

    // Actuellement, deux modes d'affichage sont disponbiles :
    // > md : mode 'desktop' (grand écran)
    // <= md : mode 'mobile'
    const isMDUp = __isBrowser__ && useMediaQuery(theme => theme.breakpoints.up('md'));


    ////////////////////////////////////////
    //                                    //
    //          Gestion du style          //
    //                                    //
    ////////////////////////////////////////

    // On crée le style
    const theme = useTheme();

    // On fusionne les styles récupérés avec un template par défaut
    // pour être sûr que toutes les propriétés soient disponibles
    // Les valeurs contenues dans le style 'style' (fournies par le serveur)
    // écraseront les valeurs par défaut
    //
    // ATTENTION : ici, 'useStyles' est une fonction retournant le résultat de
    // 'makeStyles' (retournant également une fonction) d'où le double appel.
    // Cette étape supplémentaire est nécessaire pour les valeurs associées aux
    // "media query" soient correctement mises à jour
    //
    const classes = useStyles()(
        lodashMerge(
            {
                contentArticleDetailTitle: {
                    common: {},
                    xs: {},
                    sm: {},
                    md: {},
                    lg: {},
                    xl: {},
                },
                contentArticleDetailRoot: {
                    common: {
                        display: 'flex',
                        flexDirection: 'column',
                        boxShadow: '0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)',
                        borderRadius: '0px',
                        color: 'rgba(0, 0, 0, 0.87)',
                        transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                        backgroundColor: '#fff',
                    },
                    xs: {},
                    sm: {},
                    md: {
                        borderRadius: '4px',
                    },
                    lg: {
                        borderRadius: '4px',
                    },
                    xl: {
                        borderRadius: '4px',
                    },
                },
                contentArticleDetailHeaderImg: lodashMerge(
                    {
                        common: {
                            width: '100%',
                            height: '100%',
                            maxHeight: '50vh',
                            objectFit: 'cover',
                        },
                        xs: {},
                        sm: {},
                        md: {
                            borderTopLeftRadius: '4px',
                            borderTopRightRadius: '4px',
                        },
                        lg: {
                            borderTopLeftRadius: '4px',
                            borderTopRightRadius: '4px',
                        },
                        xl: {
                            borderTopLeftRadius: '4px',
                            borderTopRightRadius: '4px',
                        },
                    },
                    (data && data.img_header && data.img_header.style) || {},
                ),
                contentArticleDetailContent: {
                    common: {
                        padding: '1.5rem',
                    },
                    xs: {},
                    sm: {},
                    md: {},
                    lg: {},
                    xl: {},
                },
                contentArticleDetailSignatureDate: {
                    common: {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-end',
                        marginRight: '1.5rem',
                        marginBottom: '1.5rem',
                        fontSize: '0.9rem',
                        fontStyle: 'italic',
                        opacity: '0.8',
                    },
                    xs: {},
                    sm: {},
                    md: {},
                    lg: {},
                    xl: {},
                },
            },
            style
        )
    );



    //////////////////////////////////////////
    //                                      //
    //          Rendu du composant          //
    //                                      //
    //////////////////////////////////////////

    return (
        <>
            {data.title &&
                <Typography
                    className={classes.contentArticleDetailTitle}
                    component="h1"
                    variant="h1"
                >
                    {data.title}
                </Typography>
            }

            <Box
                className={classes.contentArticleDetailRoot}
            >
                {data.img_header && data.img_header.src &&
                    <img
                        className={classes.contentArticleDetailHeaderImg}
                        src={data.img_header.src}
                        srcSet={data.img_header.srcset}
	                    sizes={isMDUp ? "75vw" : "100vw"}
                        title={`${data.img_header.legend} - ${data.img_header.credits}`}
                        alt={data.img_header.alt}
                    />
                }

                <Box
                    className={classes.contentArticleDetailContent}
                    dangerouslySetInnerHTML={{ __html: data.content }}
                />

                <Box className={classes.contentArticleDetailSignatureDate}>
                    <Box componant="span">
                        {data.signature}
                    </Box>
                    <Box componant="span">
                        Publié le {data.date_publication_start && date_fns_format(parseISO(data.date_publication_start), 'EEEE dd MMMM yyyy', {locale: fr})}
                    </Box>
                </Box>
            </Box>
        </>
    );
}
